import * as React from 'react';
import ProcessHeaderBase, {
  IProcessWarning,
} from '../ProcessHeaderBase/ProcessHeaderBase';
import { IProcessButton } from '../ProcessButtons/ProcessButtons';

interface IProps {
  selectedActivityFlow?: IProcessButton;
  activityFlows: IProcessButton[];
  onActivityFlowSelected: (activityFlow: IProcessButton) => void;
  truncated?: boolean;
  warnings?: IProcessWarning[];
}

const checkWarningMessage = (
  p: IProcessButton,
  warnings?: IProcessWarning[]
) => {
  const warning = warnings && warnings.find(w => w.activityFlow === p.Kod);
  return warning && warning.message;
};

/**
 * En implementering av ProcessHeaderBase med en extra check på aktiviteternas varningsmeddelanden.
 */
class ActivityFlowsHeader extends React.PureComponent<IProps> {
  render() {
    const activityFlow = this.props.selectedActivityFlow;

    return (
      <ProcessHeaderBase
        onSelect={this.props.onActivityFlowSelected}
        content={this.props.activityFlows.map(p => ({
          Kod: p.Kod,
          Benamning: p.Benamning,
          Warning: checkWarningMessage(p, this.props.warnings),
        }))}
        selected={activityFlow}
        backgroundColor="light"
        truncated={this.props.truncated}
      />
    );
  }
}

export default ActivityFlowsHeader;
